package com.milta.core.localization.translations.it

import com.milta.core.localization.LoadingAddressStrings

internal val LoadingAddress = LoadingAddressStrings(
    title = "Indirizzo di carico",
    emptyMessage = "Per ottimizzare il giro, indichi dove i suoi autisti caricano la merce. Verrà salvato per i suoi prossimi giri.",
    selectPlaceholder = "Scegli un indirizzo di carico",
    sheetSubtitle = "Dove i suoi autisti ritirano la merce.",
    startPointBadge = "Punto di partenza",
    newAddressAction = "Nuovo indirizzo",
    mobileSearchPlaceholder = "Via, numero, comune",
    webSearchPlaceholder = "Cerca un indirizzo…",
    deleteDialogTitle = "Eliminare questo indirizzo?",
    deleteDialogMessage = "«%s» non verrà più proposto. I giri già creati non cambiano.",
    webSubmitBlockedHint = "Scegli un indirizzo di carico per ottimizzare.",
    errorRequired = "Scegli un indirizzo di carico.",
)
